<template lang="pug">
    div
        v-row
            v-col(cols='6')
                v-card(light rounded elevation="4")
                    v-card-text.pa-5
                        .d-flex.align-center
                            .ml-2.mr-1.text-left
                                .text-h4.font-weight-bold {{ stats.totalAgentsInMessageCenter | number }}
                                .text-subtitle-1.font-weight-medium.volie-color-blue Agents in message center
                            v-spacer
                            .ml-auto
                                v-icon.volie-color-blue(size="60")
                                    | mdi-cellphone

            v-col(cols='6')
                v-card(light rounded elevation="4")
                    v-card-text.pa-5
                        .d-flex.align-center
                            .ml-2.mr-1.text-left
                                .text-h4.font-weight-bold {{ stats.totalAssignedConversations | number }}
                                .text-subtitle-1.font-weight-medium.volie-color-blue Assigned Conversations
                            v-spacer
                            .ml-auto
                                v-icon.volie-color-blue(size="60")
                                    | mdi-message

        v-row
            v-col(cols='12')
                v-card(light rounded elevation="4")
                    v-card-title Longest Waiting

                    v-simple-table.table-x-scroll.pa-md-3(style="width: 100%;" v-if="longestWaitTimes && longestWaitTimes.length > 0")
                        template(v-slot:default)
                            thead
                                tr
                                    th Wait Time
                                    th Agent
                                    th Customer
                            tbody
                                LongestWaitTimeRow(
                                    v-for='ccActive in longestWaitTimes'
                                    :key='ccActive.campaign_customer_active_id'
                                    :campaign-customer-active="ccActive"
                                )

                    .px-4.py-1(v-else)
                        v-alert(type="success" dense)
                            | Zero wait times

</template>

<script lang="ts">
    import Vue from 'vue';

    // Load components
    import LongestWaitTimeRow from '@/components/dashboards/live/messages/longest_wait_time_row.vue';

    export default Vue.extend({
        data() {
            return {
                longestWaitTimes: [],
                maxLongestWaitTimes: 10,
                stats: {
                    totalAgentsInMessageCenter: 0,
                    totalAssignedConversations: 0,
                },
            }
        },
        methods: {
            buildLongestWaitTimes() {

                // Verify
                if (!this.validAgents) {
                    return;
                }

                // Init
                let ccActives = [];
                this.longestWaitTimes = [];

                // Loop through and build array of records
                for (let i = 0; i < this.agents.length; i++) {

                    // Init
                    const agent = this.agents[i];
                    if (!agent || !(agent?.assigned_campaign_customer_actives?.length > 0)) {
                        continue;
                    }

                    // Init new slice
                    const tmpCCActives = agent.assigned_campaign_customer_actives.slice();
                    if (!(tmpCCActives.length > 0)) {
                        continue;
                    }

                    // Concatenate arrays
                    ccActives = ccActives.concat(tmpCCActives);
                }

                // Sort so they are in unresponded to order
                const sorted = this.sortCampaignCustomerActives(ccActives, "unresponded_to_time_in_seconds");
                if (!(sorted?.length > 0)) {
                    return;
                }

                // Loop through and check if any are waiting
                for (let i = 0; i < sorted.length; i++) {

                    // Init
                    const ccActive = { ...sorted[i] };
                    if (!(ccActive?.conversation_group?.unresponded_to_time_in_seconds !== null && ccActive?.conversation_group?.unresponded_to_time_in_seconds !== undefined)) {
                        continue;
                    }

                    // Push onto slice
                    this.longestWaitTimes.push(ccActive);

                    // Check if we have max yet
                    if (this.longestWaitTimes.length === this.maxLongestWaitTimes) {
                        break;
                    }
                }
            },
            calculateAgentCounts() {
                if (!this.validAgents) {
                    return;
                }

                // Init
                let totalAgentsInMessageCenter = 0;
                let totalAssignedConversations = 0;

                // Loop through agents and build counts
                // Note - agents can be in multiple buckets, so need to do this with if statements
                for (let i = 0; i < this.agents.length; i++) {

                    // Load agent
                    const agent = this.agents[i];
                    if (!agent) {
                        continue;
                    }

                    // If the agent isn't online, move on
                    if (agent.is_online !== true) {
                        continue;
                    }

                    // 6 is message center
                    if (agent.agent_status_type === 6) {
                        totalAgentsInMessageCenter++;
                    }

                    // Append assigned
                    if (agent.assigned_campaign_customer_actives?.length > 0) {
                        totalAssignedConversations += agent.assigned_campaign_customer_actives.length;
                    }
                }

                // Set stats
                this.stats.totalAgentsInMessageCenter = totalAgentsInMessageCenter;
                this.stats.totalAssignedConversations = totalAssignedConversations;
            },
            sortCampaignCustomerActives(ccActives, sortBy) {
                if (!(!!ccActives && ccActives.length > 0)) {
                    return [];
                }

                return ccActives.sort(function(x, y) {
                    switch (sortBy) {
                        case "unresponded_to_time_in_seconds":
                            return y?.conversation_group.unresponded_to_time_in_seconds - x?.conversation_group.unresponded_to_time_in_seconds;
                        
                        default:
                            return x?.campaign_customer_active_id - y?.campaign_customer_active_id;
                    }
                });
            },
        },
        computed: {
            validAgents() {
                return this.agents?.length > 0;
            },
        },
        components: {
            LongestWaitTimeRow,
        },
        props: {
            agents: Array,
        },
        watch: {
            agents: {
                deep: true, // This will let Vue know to look inside the array
                handler() {
                    this.calculateAgentCounts();
                    this.buildLongestWaitTimes();
                },
            },
        },
        created() {
            this.calculateAgentCounts();
        },
    });
</script>

<style lang="scss" scoped>
</style>